import type { Club } from "@/lib/api";
import { pieceColorVar } from "@/game/pieces";
import { sectionById } from "@/lib/sections";
import { SectionHeader } from "./SectionHeader";

interface JoinSectionProps {
  readonly club: Club | null;
}

export function JoinSection({ club }: JoinSectionProps) {
  const section = sectionById("join")!;
  const links = club?.links ?? [];

  return (
    <section id="join" className="band-ink border-t-2 border-ink">
      <div className="shell py-16 sm:py-20 md:py-24">
        <SectionHeader section={section} onInk />

        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <p className="display text-[clamp(2rem,5.5vw,3.5rem)] leading-[0.95]">
              Show up to a meeting.
              <br />
              That is the whole process.
            </p>
          </div>

          <ul className="grid content-start gap-3">
            {links.map((link) => (
              <li key={link.label}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center justify-between gap-4 border-2 border-field
                    bg-field px-6 py-5 text-ink transition-transform duration-100
                    hover:-translate-y-0.5"
                  style={{ boxShadow: `6px 6px 0 0 ${pieceColorVar(link.primary ? "T" : "I")}` }}
                >
                  <span className="display text-2xl">{link.label}</span>
                  <span className="meta opacity-70 transition-transform group-hover:translate-x-1">
                    {link.primary ? "Start here →" : "Follow →"}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
